import { ButtonCus } from '@/components/common/Button';
import { Textarea } from '@/components/common/Textarea';
import { useStore } from '@/hooks/useStore';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface NoteFormProps {
    ids: number[],
    isApprove: boolean,
    isBike: boolean,
    reloadData: () => void
}

export default observer(function NoteForm({ ids, isApprove, isBike, reloadData }: NoteFormProps) {
    // hooks
    const { t } = useTranslation();

    // store
    const { approveStore: { approveBikes, approveCoupons }, modalStore: { showAlertModal, hideAllModals } } = useStore();

    // state
    const [note, setNote] = useState('');

    // function
    const saveNote = async () => {
        const res = await flowResult(
            isBike ?
                approveBikes({ bikeIds: ids, approvalResults: isApprove, approveNote: note }) :
                approveCoupons({ couponIds: ids, approvalResults: isApprove, approveNote: note })
        );
        if (res) {
            hideAllModals();
            showAlertModal({
                id: 'update-success',
                type: 'success',
                content: isApprove ? t('messages.bike_is_approved') : t('messages.bike_is_rejected'),
                onClickXIcon: () => {
                    reloadData();
                }
            });
        }
    };

    return (
        <div className='flex flex-col gap-5'>
            <div>
                <label className='font-medium'>{t('field.note')}</label>
                <Textarea
                    className='w-full h-48 mt-1'
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder={t('placeholder.enter')}
                    maxLength={500}
                />
            </div>
            <div className='flex justify-center'>
                <ButtonCus onClick={saveNote} variant='default' size='sm'>{t('button.save')}</ButtonCus>
            </div>
        </div>
    );
});
